//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: () => ({
       id:'',
       url:'',
       info:''
    }),
    mounted() {
        this.getInfo()
    },
    methods: {
        setData(){
            console.log(this.$route.query.id.split('?')[0])
            this.id = this.$route.query.id.split('?')[0]
            this.url = location.href
        },

        // 获取信息
        getInfo(){
            this.$get('/pay/order/transferAccountsDetail?payOrderId='+this.$route.query.id.split('?')[0],function(res){
                if(res.code==200){
                    this.info = res.data
                }
            })
        },

        back(){
            var href= window.location.href
            var addr = href.split('/common')[0]
            if(this.info.serviceType==2&&this.info.assessType==2){  // 召开评估会
                let mchData ={
                    action:'jumpOut', 
                    jumpOutUrl:addr+'/outsourcer/releaseProMeetInfo?id='+this.info.traProjectId
                }
                let postData = JSON. stringify(mchData)
                parent.postMessage(postData, 'https://payapp.weixin.qq.com')
                // let mchData ={
                //     action:'jumpOut', 
                //     jumpOutUrl:'https://www.qq.com'
                // }
                // let postData = JSON. stringify(mchData)
                // parent.postMessage(postData, 'https://payapp.weixin.qq.com')
            }else{  // 编制类项目 委托评估
                this.$router.push({
                    path:'/outsourcer/releaseProInfo?id='+this.info.id
                })
                let mchData ={
                    action:'jumpOut', 
                    jumpOutUrl:addr+'/outsourcer/releaseProInfo?id='+this.info.traProjectId
                }
                let postData = JSON. stringify(mchData)
                parent.postMessage(postData, 'https://payapp.weixin.qq.com')
            }
        },


    },
   
}
